import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddvoucherComponent } from './addvoucher/addvoucher.component';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css']
})
export class VoucherComponent implements OnInit, AfterViewInit, OnDestroy {

  voucherColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Voucher";


  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Voucher No', field: 'voucherno' },
    { headerName: 'Voucher Date', field: 'voucherdate',type:'date' },
    { headerName: 'Voucher Amount', field: 'voucheramt',type:'decimal' },
    { headerName: 'Description', field: 'description' },
    { headerName: 'Refno', field: 'refno' },

  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) { this.fnServiceChanges(); }

  //User Check
   //User Check
   fnServiceChanges(){
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
          if(this.loginService.fnCheckUser()){                
              this.fnCheckPrivilage();
              if(this.isview){
                this.isloading=true;
                this.fnOnInitForm();
              }
              else{
                this.fnUserFailedForm();
              }    
          }
          else{
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
    });
  }


  ngOnInit() {
    try{
      if (this.loginService.fnCheckCompany()) {
      if(this.loginService.fnCheckUser()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }
  fnOnInitForm() {
    this.fngetVoucher();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }

  fngetVoucher() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'voucherid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
     
    }
    this.appService.getVoucher(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.voucherColl = res.json().result;
            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  fnAddVoucher() {
    try {
      const modalRef = this.productFindService.open(AddvoucherComponent, { size: <any>'l', backdrop: 'static' });


      modalRef.componentInstance.ngOnInit();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetVoucher();

      });


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditVoucher(pBO) {

    try {
    
      var deptid = pBO.voucherid
      if (!this.isedit) {
        return;
      }
      const modalRef = this.productFindService.open(AddvoucherComponent, { size: <any>'l', backdrop: 'static' });
      modalRef.componentInstance.voucherid = deptid;

      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetVoucher();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  public fnDeleteConfirm(pBO) {
    try {
      var deptid = pBO.voucherid
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Voucher?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteVoucher(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteVoucher(deptid) {
    var data = {
      'voucherid': deptid,
    }
    this.appService.fnDeleteVoucher(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The Voucher has been deleted successfully.");

            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetVoucher();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }







  private fnSetDataTable() {

  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnActionExportClick()  {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.voucherColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  }

  fnGetDescription(id) {
    const index = this.voucherColl.findIndex(sku => sku.voucherid === id);

    if (index) {
      return this.voucherColl[index].Voucheramt;
    }
    else {
      return "";
    }

  }

  public fnSearchDatatable(value) {


  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
